import { apiFetch } from "./apiClient";

export function listarDeudas() {
    return apiFetch("/api/deudas");
}

export function crearDeuda(payload) {
    return apiFetch("/api/deudas", {
        method: "POST",
        body: JSON.stringify(payload),
    });
}

export function actualizarDeuda(id, payload) {
    return apiFetch(`/api/deudas/${id}`, {
        method: "PUT",
        body: JSON.stringify(payload),
    });
}

export function listarCuotasDeuda(idDeuda) {
    return apiFetch(`/api/deudas/${idDeuda}/cuotas`);
}

export function crearCuotaDeuda(idDeuda, payload) {
    return apiFetch(`/api/deudas/${idDeuda}/cuotas`, {
        method: "POST",
        body: JSON.stringify(payload),
    });
}

export function actualizarCuotaDeuda(idCuota, payload) {
    return apiFetch(`/api/deudas/cuotas/${idCuota}`, {
        method: "PUT",
        body: JSON.stringify(payload),
    });
}

export function eliminarCuotaDeuda(idCuota) {
    return apiFetch(`/api/deudas/cuotas/${idCuota}`, {
        method: "DELETE",
    });
}

export function pagarCuotaDeuda(idCuota, payload) {
    return apiFetch(`/api/deudas/cuotas/pagar/${idCuota}`, {
        method: "PUT",
        body: JSON.stringify(payload),
    });
}

export function eliminarDeuda(idDeuda) {
    return apiFetch(`/api/deudas/${idDeuda}`, {
        method: "DELETE",
    });
}